<template>
    <div>
        <h1>Alkene</h1>
        <p>
            Alkene sind ungesättigte, acyclische Kohlenwasserstoffe. Das heißt,
            sie bestehen ausschließlich aus C und H Atomen mit mindestens einer
            Doppelbindung und besitzen keine Kohlenstoffringe. Für alle gilt
            eine allgemeine Strukturformel von C<sub>n</sub>H<sub>2n</sub>. Die
            Doppelbindung ist nicht frei drehbar und besteht aus einer Sigma-
            und einer Pi-Bindung, d.h. einer Überlappung von
            sp2-Hybrid-Orbitalen.
        </p>
        <img
            src="@/assets/img/stoffe/alkene/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Alkene"
            title="Allgemeine Struktur der Alkene"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>C<sub>2</sub>H<sub>4</sub></td>
                    <td>Ethen</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>C<sub>3</sub>H<sub>6</sub></td>
                    <td>Propen</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>4</sub>H<sub>8</sub></td>
                    <td>Buten</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>5</sub>H<sub>10</sub></td>
                    <td>Penten</td>
                </tr>
                <tr>
                    <th>5.</th>
                    <td>C<sub>6</sub>H<sub>12</sub></td>
                    <td>Hexen</td>
                </tr>
                <tr>
                    <th>6.</th>
                    <td>C<sub>7</sub>H<sub>14</sub></td>
                    <td>Hepten</td>
                </tr>
                <tr>
                    <th>7.</th>
                    <td>C<sub>8</sub>H<sub>16</sub></td>
                    <td>Octen</td>
                </tr>
                <tr>
                    <th>8.</th>
                    <td>C<sub>9</sub>H<sub>18</sub></td>
                    <td>Nonen</td>
                </tr>
                <tr>
                    <th>9.</th>
                    <td>C<sub>10</sub>H<sub>20</sub></td>
                    <td>Decen</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n</sub></td>
                </tr>
                <tr>
                    <th>Hinweis:</th>
                    <td>
                        Es gibt kein <em>Methen</em>, da bei einem einzelnen
                        C-Atom keine Doppelbindung vorliegen kann.
                    </td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Halogenierung (<router-link
                    to="/reaktionen/elektrophile-addition"
                    >Elektrophile Addition</router-link
                >) =>
                <router-link to="halogenalkane">Halogenalkane</router-link>
            </li>
            <li>Hydrierung => <router-link to="alkane">Alkane</router-link></li>
            <li>
                Hydratisierung =>
                <router-link to="alkohole">Alkohole</router-link>
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/alkene/penten.png"
            alt="Beispielhafte Strukturformel: Penten"
            title="Beispielhafte Strukturformel: Penten"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>bestehen nur aus C-Atomen und H-Atomen</li>
                        <li>besitzen mindestens eine Doppelbindung</li>
                        <li>ungesättigte, acyclische Kohlenwasserstoffe</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n</sub></td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>ungesättigt</li>
                        <li>hydrophob</li>
                        <li>lipophil</li>
                        <li>brennbar</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>
                    Einfachbindungen (Sigma-Bindungen) und Doppelbindungen
                    (Sigma- & Pi-Bindungen)
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
